module.exports = __webpack_public_path__ + "static/media/nl-flag.21214640.svg";